<h2>Percorsi Regolamentati</h2>
<p>In rapporto a particolari profili caratteristici operanti nel mercato del lavoro lombardo, Regione Lombardia ha definito
una specifica regolamentazione per l'organizzazione dei percorsi formativi, stabilendo requisiti di accesso ai medesimi,
modalità di accertamento delle competenze in esito, composizione delle commissioni d'esame e standard professionali per
il rilascio dell'attestato finale di competenza.</p>

<p>Tali percorsi afferiscono esclusivamente a regolamentazione di Regione Lombardia, pertanto i relativi attestati non
hanno valore abilitante.</p>
<div class="example-container mat-elevation-z8">
  <div class="example-table-container">

    <table mat-table [dataSource]="dataSource" class="example-table" matSort matSortActive="descrizione" matSortDisableClear matSortDirection="asc">
       <ng-container matColumnDef="descrizione">
           <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
               Descrizione
             </th>
             <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
       </ng-container>
       <ng-container matColumnDef="azioni">
           <th mat-header-cell *matHeaderCellDef>
               Azioni
             </th>
             <td mat-cell *matCellDef="let element">
               <mat-icon class="green" (click)="downloadPercorso(element)"
               matTooltip="Download Documento">download</mat-icon>
               <mat-icon class="green" (click)="elencoCorsi(element)"
               matTooltip="Visualizza Elenco Corsi">search</mat-icon>
              </td>
       </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height:24px !important;"></tr>
    </table>
  </div>

  <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [length]="totalItems"
  [pageIndex]="pageIndex" (page)="onPaginateChange($event)" showFirstLastButtons></mat-paginator>
</div>
